module.exports = __webpack_public_path__ + "static/img/img-features-feature-6-parents_en.9df187f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-6-parents_en.png
// module id = hFjE
// module chunks = 18